import React from "react";
import { Route, Routes } from "react-router-dom";
import { userRoutes, authRoutes, kioskRoutes } from "./routes/allRoutes";
import ProtectedRoute from "./routes/ProtectedRoute";

import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

import { AuthProvider } from "./contexts/AuthContext";
import { TenantProvider } from "./contexts/TenantContext";
import { LayoutProvider } from "./contexts/LayoutContext";
import { AlertProvider } from "./contexts/AlertContext";

import { useLayout } from "./hooks/useLayout";

import "./assets/scss/theme.scss";
import 'react-toastify/dist/ReactToastify.css';
import "./services/firebase";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import PerformanceTracker from "./components/Common/PerformanceTracker";
import WhatsAppButton from "./components/Common/WhatsAppButton";

const AppContent = () => {
    const { layoutType } = useLayout();
    const Layout = layoutType === "horizontal" ? HorizontalLayout : VerticalLayout;

    return (
        <Routes>
            {/* Non-authenticated routes */}
            {authRoutes.map((route, idx) => (
                <Route
                    key={idx}
                    path={route.path}
                    element={
                        <NonAuthLayout>{route.component}</NonAuthLayout>
                    }
                />
            ))}

            {/* Authenticated routes */}
            {userRoutes.map((route, idx) => (
                <Route
                    key={idx}
                    path={route.path}
                    element={
                        <ProtectedRoute>
                            <Layout>{route.component}</Layout>
                        </ProtectedRoute>
                    }
                />
            ))}

            {/* Kiosk routes (Authenticated, without layout) */}
            {kioskRoutes.map((route, idx) => (
                <Route
                    key={idx}
                    path={route.path}
                    element={
                        <ProtectedRoute>
                            {route.component}
                        </ProtectedRoute>
                    }
                />
            ))}
        </Routes>
    );
};

const App = () => {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <TenantProvider>
                    <AlertProvider>
                        <LayoutProvider>
                            <PerformanceTracker />
                            <ToastContainer
                                position="top-center"
                                autoClose={3000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme="colored"
                            />
                            <AppContent />
                            <WhatsAppButton />
                        </LayoutProvider>
                    </AlertProvider>
                </TenantProvider>
            </AuthProvider>
        </ErrorBoundary>
    );
};

export default App;
